import * as angular from "angular";

export default angular.module('directives.debug', [])
    .directive('debug', function () {
        return {
            restrict: 'E',
            scope: {
                title: '@model',
                model: '<model'
            },
            link: (scope, element, attrs) => {

            },
            template: require('./Debug.html')
        };
    })
    .name;
